import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.125 7.375 13.25 2.25m.5 2.5v-3h-3m-3.875 0h-1.25C2.5 1.75 1.25 3 1.25 6.125v3.75C1.25 13 2.5 14.25 5.625 14.25h3.75c3.125 0 4.375-1.25 4.375-4.375v-1.25"
    }, null, -1)
  ]))]))
}
export default { render: render }